/* MISUNDERSTOOD — Shopify theme behaviors.
   Replaces the original DCLogic SPA runtime with native DOM + Shopify AJAX cart. */
(function () {
  'use strict';

  /* ---------------- Countdown ---------------- */
  function pad(n) { return String(n).padStart(2, '0'); }
  function initCountdown() {
    var host = document.querySelector('[data-drop-ts]');
    if (!host) return;
    var ts = parseInt(host.getAttribute('data-drop-ts'), 10);
    if (!ts) return;
    function tick() {
      var diff = Math.max(0, ts - Date.now());
      var dd = Math.floor(diff / 86400000); diff -= dd * 86400000;
      var hh = Math.floor(diff / 3600000); diff -= hh * 3600000;
      var mm = Math.floor(diff / 60000); diff -= mm * 60000;
      var ss = Math.floor(diff / 1000);
      var map = { d: pad(dd), h: pad(hh), m: pad(mm), s: pad(ss) };
      ['d', 'h', 'm', 's'].forEach(function (k) {
        document.querySelectorAll('[data-cd="' + k + '"]').forEach(function (el) {
          if (el.textContent !== map[k]) el.textContent = map[k];
        });
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------- Sticky nav solidify ---------------- */
  function initNav() {
    var nav = document.getElementById('msu-nav');
    if (!nav) return;
    var always = nav.getAttribute('data-always-solid') === 'true';
    var raf = null;
    function update() {
      raf = null;
      var solid = always || (window.scrollY || window.pageYOffset || 0) > (window.innerHeight * 0.6);
      nav.classList.toggle('solid', solid);
    }
    function onScroll() { if (raf) return; raf = requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    requestAnimationFrame(update);
  }

  /* ---------------- Toast ---------------- */
  var toastT = null;
  function toast(msg) {
    var el = document.getElementById('msu-toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-open');
    if (toastT) clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('is-open'); }, 2200);
  }

  /* ---------------- Drawer / modal open helpers ---------------- */
  function openEl(id) { var el = document.getElementById(id); if (el) el.classList.add('is-open'); }
  function closeEl(id) { var el = document.getElementById(id); if (el) el.classList.remove('is-open'); }

  /* ---------------- Cart (AJAX + Section Rendering) ---------------- */
  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }
  function updateCartCounts() {
    var inner = document.getElementById('cart-drawer-inner');
    if (!inner) return;
    setCartCount(inner.getAttribute('data-cart-count-value') || '0');
  }

  function renderCart(sections) {
    if (!sections || !sections['cart-drawer']) return;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.getElementById('cart-drawer-inner');
    var live = document.getElementById('cart-drawer-inner');
    if (fresh && live) {
      live.innerHTML = fresh.innerHTML;
      var c = fresh.getAttribute('data-cart-count-value');
      if (c != null) live.setAttribute('data-cart-count-value', c);
      setCartCount(c || '0');
    }
  }

  function postCart(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addToCart(variantId, qty) {
    return postCart('/cart/add.js', { id: variantId, quantity: qty || 1 })
      .then(function (data) {
        if (data && data.status) { toast(data.description || 'Sold out'); return; }
        renderCart(data.sections);
        openEl('cart-drawer');
        toast('Added to bag');
      });
  }

  function changeLine(key, quantity) {
    return postCart('/cart/change.js', { id: key, quantity: quantity })
      .then(function (cart) { renderCart(cart.sections); });
  }

  /* ---------------- Delegated clicks ---------------- */
  function initDelegation() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-cart-open],[data-cart-close],[data-size-guide-open],[data-size-guide-close],[data-qty-change],[data-cart-remove],[data-color],[data-size],[data-gallery]');
      if (!t) return;

      if (t.hasAttribute('data-cart-open')) { e.preventDefault(); openEl('cart-drawer'); return; }
      if (t.hasAttribute('data-cart-close')) { e.preventDefault(); closeEl('cart-drawer'); return; }
      if (t.hasAttribute('data-size-guide-open')) { e.preventDefault(); openEl('size-guide'); return; }
      if (t.hasAttribute('data-size-guide-close')) { e.preventDefault(); closeEl('size-guide'); return; }

      if (t.hasAttribute('data-qty-change')) {
        e.preventDefault();
        var line = t.closest('[data-line-key]');
        if (!line) return;
        var key = line.getAttribute('data-line-key');
        var cur = parseInt(line.getAttribute('data-line-qty'), 10) || 0;
        var next = cur + parseInt(t.getAttribute('data-qty-change'), 10);
        changeLine(key, Math.max(0, next));
        return;
      }
      if (t.hasAttribute('data-cart-remove')) {
        e.preventDefault();
        var ln = t.closest('[data-line-key]');
        if (ln) changeLine(ln.getAttribute('data-line-key'), 0);
        return;
      }

      if (t.hasAttribute('data-color')) { e.preventDefault(); PDP.setColor(t.getAttribute('data-color')); return; }
      if (t.hasAttribute('data-size')) { if (t.disabled) return; e.preventDefault(); PDP.setSize(t.getAttribute('data-size')); return; }
      if (t.hasAttribute('data-gallery')) { e.preventDefault(); PDP.setGallery(t.getAttribute('data-gallery')); return; }
    });
  }

  /* ---------------- Product page (variant picker) ---------------- */
  var PDP = {
    data: null, color: null, size: null, gallery: 'flat',
    init: function () {
      var script = document.getElementById('product-json');
      if (!script) return;
      try { this.data = JSON.parse(script.textContent); } catch (e) { return; }
      this.color = script.getAttribute('data-init-color') || null;
      this.size = script.getAttribute('data-init-size') || null;
      this.gallery = 'flat';
      this.render();
      var form = document.getElementById('product-form');
      if (form) {
        var self = this;
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = self.current();
          if (!v || !v.available) return;
          addToCart(v.id, 1);
        });
      }
      // swipe to cycle gallery
      var stage = document.getElementById('pdp-stage');
      if (stage) {
        var sx = null, sy = null, self2 = this;
        stage.addEventListener('touchstart', function (e) { var p = e.touches[0]; sx = p.clientX; sy = p.clientY; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx == null) return; var p = e.changedTouches[0];
          var dx = p.clientX - sx, dy = p.clientY - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self2.setGallery(self2.gallery === 'flat' ? 'life' : 'flat');
          sx = null;
        }, { passive: true });
      }
    },
    variantsForColor: function (c) {
      if (!this.data) return [];
      return this.data.variants.filter(function (v) { return v.color === c; });
    },
    current: function () {
      if (!this.data) return null;
      var self = this;
      var match = this.data.variants.filter(function (v) {
        return (self.color == null || v.color === self.color) && (self.size == null || v.size === self.size);
      });
      return match[0] || null;
    },
    setColor: function (c) {
      this.color = c;
      // keep size if available for this color, else pick first available
      var avail = this.variantsForColor(c);
      var hasSize = avail.some(function (v) { return v.size === this.size && v.available; }, this);
      if (!hasSize) {
        var first = avail.find(function (v) { return v.available; }) || avail[0];
        if (first) this.size = first.size;
      }
      this.gallery = 'flat';
      this.render();
    },
    setSize: function (s) { this.size = s; this.render(); },
    setGallery: function (g) { this.gallery = g; this.render(); },
    images: function () {
      var v = this.current() || {};
      return { flat: v.img || '', life: v.life || v.img || '' };
    },
    render: function () {
      if (!this.data) return;
      var v = this.current();
      var imgs = this.images();
      // main image
      var main = document.getElementById('pdp-main-img');
      if (main) {
        var src = this.gallery === 'life' ? imgs.life : imgs.flat;
        if (src && main.getAttribute('src') !== src) { main.setAttribute('src', src); main.style.animation = 'none'; void main.offsetWidth; main.style.animation = 'msu-in .4s ease'; }
      }
      // color underlines
      document.querySelectorAll('[data-color]').forEach(function (b) {
        b.style.borderBottomColor = (b.getAttribute('data-color') === this.color) ? '#15140f' : 'transparent';
      }, this);
      var cname = document.getElementById('pdp-color-name');
      if (cname) cname.textContent = this.color || '—';
      // size availability + highlight
      var availColor = this.variantsForColor(this.color);
      document.querySelectorAll('[data-size]').forEach(function (b) {
        var s = b.getAttribute('data-size');
        var match = (this.color ? availColor : this.data.variants).filter(function (x) { return x.size === s; });
        var exists = match.length > 0;
        var available = match.some(function (x) { return x.available; });
        var sel = (s === this.size) && available;
        b.disabled = !available;
        b.style.cursor = available ? 'pointer' : 'not-allowed';
        b.style.background = sel ? '#15140f' : 'transparent';
        b.style.color = sel ? '#ffffff' : (available ? '#15140f' : '#bdb8ae');
        b.style.textDecoration = available ? 'none' : 'line-through';
      }, this);
      // thumbs / dots
      document.querySelectorAll('[data-gallery]').forEach(function (b) {
        var g = b.getAttribute('data-gallery');
        var on = g === this.gallery;
        if (b.classList.contains('pdp-dot')) { b.style.background = on ? '#15140f' : 'rgba(0,0,0,.22)'; }
        else { b.style.borderColor = on ? '#15140f' : 'rgba(0,0,0,.16)'; }
        var ti = b.querySelector('img');
        if (ti) ti.setAttribute('src', g === 'life' ? imgs.life : imgs.flat);
      }, this);
      // price + status + add button + hidden id
      var price = document.getElementById('pdp-price');
      var status = document.getElementById('pdp-status');
      var addBtn = document.getElementById('pdp-add');
      var idInput = document.getElementById('pdp-variant-id');
      var available = v && v.available;
      if (price && v) price.textContent = v.priceLabel;
      if (status) status.textContent = available ? 'In stock' : 'Sold out — no restock';
      if (idInput && v) idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.style.background = available ? '#15140f' : '#ddd9d2';
        addBtn.style.color = available ? '#ffffff' : '#a9a39a';
        addBtn.style.cursor = available ? 'pointer' : 'not-allowed';
        var lbl = addBtn.querySelector('[data-add-label]');
        if (lbl) lbl.textContent = available ? ('Add to bag — ' + (v ? v.priceLabel : '')) : 'Sold out';
      }
    }
  };

  /* ---------------- Boot ---------------- */
  function boot() {
    initCountdown();
    initNav();
    initDelegation();
    updateCartCounts();
    PDP.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
